<template>
  <div>
    <div
      v-if="!$route.params.operation"
      class="card content-crud"
    >
      <div
        class="ibox-title"
        style="padding: 16px"
      >
        <h3>
          Usuários
          <div style="float: right; margin-top: -3px">
            <button
              class="btn btn-success mr-2"
              title="Exportar usuários para Excel"
              @click="showExportModal = true"
            >
              <i class="fas fa-file-excel mr-1" />
              Exportar
            </button>
            <router-link
              :to="endPoint + 'add'"
              class="btn btn-primary"
            >Novo Usuário</router-link>
          </div>
        </h3>
      </div>
    </div>

    <base-crud
      crud-name="Usuários"
      new-text="Novo Usuário"
      :table="userTable"
      :columns="columns"
      :options="options"
      :end-point="endPoint"
      :enable-add="false"
      :enable-edit="true"
      :enable-delete="true"
      :enable-view="false"
      :data-form="dataForm"
    />

    <!-- Modal de Exportação -->
    <b-modal
      v-model="showExportModal"
      title="Exportar Usuários"
      size="md"
      ok-title="Exportar"
      ok-variant="success"
      cancel-title="Cancelar"
      :ok-disabled="exporting"
      @ok="exportUsers"
    >
      <div class="form-group">
        <label>Empresa</label>
        <v-select
          v-model="selectedCompany"
          :options="companies"
          label="company_name"
          :reduce="(c) => c.id"
          placeholder="Todas as empresas"
          clearable
        />
        <small class="form-text text-muted">
          Deixe em branco para exportar usuários de todas as empresas
        </small>
      </div>

      <div
        v-if="exporting"
        class="text-center mt-3"
      >
        <i class="fas fa-spinner fa-spin mr-2" />
        Exportando...
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseCrud from '../../layouts/Base/BaseCrud'

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      userTable: 'userTable',
      users: [],
      pages: [],
      url: '',
      exporting: false,
      showExportModal: false,
      selectedCompany: null,
      companies: [],
      columns: [
        'id',
        'photo',
        'name',
        'is_admin',
        'email',
        'company_id',
        'actions',
      ],
      tableData: ['id', 'name', 'photo', 'name', 'email', 'is_admin'],
      options: {
        filterByColumn: true,
        filterable: ['id', 'name', 'name', 'email', 'company_id'],
        sortable: ['id', 'name'],
        pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: 'ID',
          photo: 'Foto',
          name: 'Nome',
          is_admin: 'Nível de acesso',
          email: 'E-mail',
          company_id: 'Empresa',
          actions: 'Ações',
        },
        templates: {
          is_admin(h, row, index) {
            return row.is_admin == 1
              ? 'Adminsitrador Geral'
              : row.is_admin == 2
                ? 'Adminsitrador Empresa'
                : row.is_admin == 4
                  ? 'Supervisor'
                  : 'Usuário Padrão'
          },
          company_id(h, row, index) {
            return row.company ? row.company.company_name : 'Indisponível'
          },
        },
        requestFunction(data) {
          const requestData = {}

          const query = this.$parent.$parent.$parent.query(data.query)
          requestData.params = data
          requestData.params.query = ''
          requestData.params.with = ['company', 'alocations']

          return axios.get(`${this.url}?${query}`, requestData).catch(
            e => {
              this.dispatch('error', e)
            },
          )
        },
      },
      endPoint: 'users/',

      dataForm: {},
    }
  },
  mounted() {
    this.loadCompanies()
  },
  methods: {
    loadCompanies() {
      const api = `${this.$store.state.api}companies`
      axios
        .get(api)
        .then(response => {
          this.companies = response.data.data || response.data || []
        })
        .catch(err => {
          console.error('Erro ao carregar empresas:', err)
          this.$message('Erro', 'Erro ao carregar lista de empresas', 'error')
        })
    },
    query(query) {
      const columns = {
        id: 'id',
        name: 'name',
        email: 'email',
        company_id: 'company[company_name]',
      }
      let filters = ''
      $.each(query, (index, value) => {
        filters += `${columns[index]}=${value}&`
      })

      return filters
    },
    exportUsers() {
      this.exporting = true

      const params = {}

      // Se uma empresa foi selecionada, usa ela
      if (this.selectedCompany) {
        params.company_id = this.selectedCompany
      }

      const api = `${this.$store.state.api}users/export`

      axios
        .get(api, { params, responseType: 'blob' })
        .then(response => {
          const disposition = response.headers['content-disposition'] || ''
          let filename = `usuarios_${new Date().toISOString().split('T')[0]}.xlsx`
          const match = disposition.match(/filename="?([^";]+)"?/)
          if (match) filename = match[1]

          const mime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          const blob = new Blob([response.data], { type: mime })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)

          this.$message(
            'Sucesso',
            'Usuários exportados com sucesso!',
            'success',
          )

          // Fechar modal após exportação bem-sucedida
          this.showExportModal = false
          this.selectedCompany = null
        })
        .catch(err => {
          console.error('Erro ao exportar:', err)
          this.$message(
            'Erro',
            err.response && err.response.data
              ? err.response.data
              : 'Erro ao exportar usuários',
            'error',
          )
        })
        .finally(() => {
          this.exporting = false
        })
    },
  },
}
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.ibox-title h3 {
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.btn.mr-2 {
  margin-right: 8px;
}
</style>
